import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=c6c6da5a&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=c6c6da5a&prod&scoped=true&lang=css"
import style1 from "./resetPassword.vue?vue&type=style&index=1&id=c6c6da5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c6da5a",
  null
  
)

export default component.exports